module.exports = __webpack_public_path__ + "static/fusion01-e4f99c10b172e126f9d6f8f7fd846f5c.png";